import React from 'react';
import CrmDashboardPage from '../components/CrmDashboardPage';

const CrmDashboardApp = (props) => (
  <CrmDashboardPage {...props} />
);

export default CrmDashboardApp;
